import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'clientPortalDetailsUrl',
})
export class ClientPortalDetailsUrlPipe implements PipeTransform {
  baseUrl = '/property-details';

  transform(value: any): string {
    const id = value?.ITEMID ?? value?.ITEM_ID;

    if(!id){
      console.log("Missing ItemID or ITEM_ID: ", value);
      return `${this.baseUrl}/unknown`;
    }

    return `${this.baseUrl}/${id}`;
  }
}
